export const ROLE_THYAGA_ADMINISTRATOR = 'ROLE_THYAGA_ADMINISTRATOR';
export const ROLE_MERCHANT_ADMINISTRATOR = 'ROLE_MERCHANT_ADMINISTRATOR';
export const ROLE_SUB_MERCHANT_ADMINISTRATOR =
  'ROLE_SUB_MERCHANT_ADMINISTRATOR';
export const ROLE_THYAGA_ACCOUNTANT = 'ROLE_THYAGA_ACCOUNTANT';
export const ROLE_THYAGA_SCHEDULER = 'ROLE_THYAGA_SCHEDULER';
export const ROLE_MERCHANT_REDEMPTIONS = 'ROLE_MERCHANT_REDEMPTIONS';
export const ROLE_THYAGA_CUSTOMER_CARE = 'ROLE_THYAGA_CUSTOMER_CARE';
export const ROLE_THYAGA_MERCHANT_CONTROLLER =
  'ROLE_THYAGA_MERCHANT_CONTROLLER';
export const ROLE_THYAGA_SALES_AGENT = 'ROLE_THYAGA_SALES_AGENT';
export const ROLE_THYAGA_MARKETING = 'ROLE_THYAGA_MARKETING';
export const ROLE_REWARD_CLIENT_USER = 'ROLE_REWARD_CLIENT_USER';
export const ROLE_CLIENT_CAMPAIGN_ADMINISTRATOR =
  'ROLE_CLIENT_CAMPAIGN_ADMINISTRATOR';

export const MERCHANT_SCOPED_ROLES = [
  ROLE_MERCHANT_ADMINISTRATOR,
  ROLE_SUB_MERCHANT_ADMINISTRATOR,
];

export const CLIENT_SCOPED_ROLES = [
  ROLE_REWARD_CLIENT_USER,
  ROLE_CLIENT_CAMPAIGN_ADMINISTRATOR,
];

export const ROLES_ACCESSIBLE_BY = {
  [ROLE_THYAGA_ADMINISTRATOR]: [
    ROLE_THYAGA_ADMINISTRATOR,
    ROLE_MERCHANT_ADMINISTRATOR,
    ROLE_SUB_MERCHANT_ADMINISTRATOR,
    ROLE_THYAGA_ACCOUNTANT,
    ROLE_THYAGA_SCHEDULER,
    ROLE_MERCHANT_REDEMPTIONS,
    ROLE_THYAGA_CUSTOMER_CARE,
    ROLE_THYAGA_MERCHANT_CONTROLLER,
    ROLE_THYAGA_SALES_AGENT,
    ROLE_THYAGA_MARKETING,
    ROLE_REWARD_CLIENT_USER,
    ROLE_CLIENT_CAMPAIGN_ADMINISTRATOR,
  ],
  [ROLE_THYAGA_MERCHANT_CONTROLLER]: [
    ROLE_MERCHANT_ADMINISTRATOR,
    ROLE_SUB_MERCHANT_ADMINISTRATOR,
  ],
};

export const getAccessibleRoles = (currentUserRole) => {
  return ROLES_ACCESSIBLE_BY[currentUserRole] || [];
};

export const getRoleLabel = (role) => (role ? role.replace(/_/g, ' ') : role);

// Admin user rows carry the merchant(s) they're scoped to inline:
// ROLE_MERCHANT_ADMINISTRATOR rows have `merchants: [merchant, ...]`,
// ROLE_SUB_MERCHANT_ADMINISTRATOR rows have `subMerchant: { merchant, ... }`.
export const getRowMerchants = (rowData) => {
  if (!rowData) return [];
  if (Array.isArray(rowData.merchants) && rowData.merchants.length > 0) {
    return rowData.merchants;
  }
  if (rowData.subMerchant && rowData.subMerchant.merchant) {
    return [rowData.subMerchant.merchant];
  }
  return [];
};

// CLIENT_SCOPED_ROLES rows carry the client they're scoped to inline, either
// as a nested `client: { id, name, ... }` object or as a flat `clientId`
// (with an optional `clientName`) on the row itself.
export const getRowClient = (rowData) => {
  if (!rowData) return null;
  if (rowData.client) return rowData.client;
  if (rowData.clientId) {
    return { id: rowData.clientId, name: rowData.clientName || null };
  }
  return null;
};
